import { defineMessages, MessageDescriptor } from 'react-intl';

/** Why the AI buttons of the Composer cannot run now. */
export type ComposerAiBlock = 'demo' | 'readOnly' | 'noRelease' | 'noChannel' | 'writing';

export interface ComposerAiBlockFacts {
  /** The active artist is the read-only example artist (LaziiBee). */
  isDemo: boolean;
  /** The active artist is above the artist limit of the plan: every write answers 403. */
  isReadOnly: boolean;
  hasRelease: boolean;
  channelCount: number;
  isWriting: boolean;
}

/**
 * The first reason that stops "Write with AI" and "Tailor per platform", or null when they can
 * run. The AI writes from the release and for the picked channels, so each one is a reason of
 * its own. The buttons show the reason of this rule, never a general one.
 */
export function composerAiBlock(facts: ComposerAiBlockFacts): ComposerAiBlock | null {
  if (facts.isDemo) {
    return 'demo';
  }
  if (facts.isReadOnly) {
    return 'readOnly';
  }
  if (!facts.hasRelease) {
    return 'noRelease';
  }
  if (facts.channelCount === 0) {
    return 'noChannel';
  }
  if (facts.isWriting) {
    return 'writing';
  }
  return null;
}

export const composerAiBlockMessages: Record<ComposerAiBlock, MessageDescriptor> = defineMessages({
  demo: {
    id: 'app.sml.promote.composer.ai.reason.demo',
    defaultMessage: 'This is the example artist. Pick your own artist to write with AI.',
  },
  readOnly: {
    id: 'app.sml.promote.composer.ai.reason.readOnly',
    defaultMessage: 'This artist is above the artist limit of your plan. Upgrade to write with AI.',
  },
  noRelease: {
    id: 'app.sml.promote.composer.ai.reason.noRelease',
    defaultMessage: 'Pick a release first. The AI writes from the release.',
  },
  noChannel: {
    id: 'app.sml.promote.composer.ai.reason.noChannel',
    defaultMessage: 'Pick a channel first. The AI writes for the channels you pick.',
  },
  writing: {
    id: 'app.sml.promote.composer.ai.reason.writing',
    defaultMessage: 'The AI is writing. Wait a moment.',
  },
});
